import { resolveEnvironmentBadge } from './environmentBadgeResolver';

/**
 * Shows the Firebase environment on non-production surfaces.
 * Firebase project identity is authoritative; localhost and Vite DEV are not.
 */
export default function EnvironmentBadge() {
  const badge = resolveEnvironmentBadge({
    mode: import.meta.env.MODE,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    hostname: window.location.hostname,
  });

  if (!badge) return null;

  return (
    <div className="fixed bottom-20 lg:bottom-4 right-4 z-50 pointer-events-none">
      <div
        aria-label={`${badge.label} environment`}
        className={`badge ${badge.className} badge-lg font-semibold shadow-lg`}
      >
        {badge.label}
      </div>
    </div>
  );
}
